import { createSlice } from "@reduxjs/toolkit";

const editMantraSlice = createSlice({
  name: "editMantra",
  initialState: {
    isEditOpen: false,
  },
  reducers: {
    toogleEdit: (state) => {
      state.isEditOpen = !state.isEditOpen;
    },
  },
});

export const { toogleEdit } = editMantraSlice.actions;
export default editMantraSlice.reducer;